import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { User } from '/src/lib/models';
import type { TSigninRequest, TSigninResponse, TSignoutRequest, TSignoutResponse } from '/src/lib/types';

export class AuthenticationService {
  /**
   * Signin
   */
  public static async signin(req: TSigninRequest): CancelablePromise<User> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/auth/signin',
      body: req,
    })) as TSigninResponse;

    return res;
  }

  /**
   * Signout
   */
  public static async signout(req: TSignoutRequest): CancelablePromise<TSignoutResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/auth/signout',
      body: req,
    })) as TSignoutResponse;

    return res;
  }
}
